import z from "zod"

export const DateSchema = z
  .union([z.string().date(), z.date()])
  .transform((d) => (d instanceof Date ? d.toISOString().split('T')[0] : d))
  .optional()
  .nullable()

export const DateTimeSchema = z
  .preprocess((value) => {
    if (value === undefined || value === null || value instanceof Date) {
      return value
    }

    // if provided value is a string or number type, try parse as date
    if (typeof value === 'string' || typeof value === 'number') {
      const date = new Date(value)

      return Number.isNaN(date.getTime()) ? undefined : date
    }

    return undefined
  }, z.date())
  .transform((date: Date) => date.toISOString())

export const QueryBooleanSchema = z.preprocess(
  (val) => val === '1' || val === 1 || val === true || val === 'true',
  z.boolean(),
)
